import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationModel } from 'src/app/models/common/confirmationModel';
import { ConfirmationResult } from 'src/app/models/common/confirmationResult';

@Component({
  selector: 'app-asset-exists-dialog',
  templateUrl: './asset-exists-dialog.component.html',
  styleUrl: './asset-exists-dialog.component.scss'
})
export class AssetExistsDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public confirmationData: ConfirmationModel, private matDialogRef: MatDialogRef<AssetExistsDialogComponent>) {
  }
 
  viewDetails() {
    this.matDialogRef.close(ConfirmationResult.confirm);
  }
  cancel() {
    this.matDialogRef.close(ConfirmationResult.cancel);
  }
}
